export default __webpack_public_path__ + "fffe86fa42f1f2d103cbf1b038b4466b.png";